var _ = require('underscore');
var TorsoView = require('backbone-torso/modules/View');
var patientSummaryTemplate = require('./patientSummaryTemplate.hbs');
var userService = require('./../user/userService');
var DemographicsDataBehavior = require('./../demographics/DemographicsDataBehavior');
var applicationUtils = require('./../applicationUtils');
var demographicsFeatureConfigModel = require('./../demographics/demographicsFeatureConfigModel');

var FIELD_TYPES = {
  SSN_LAST_4: 'ssnLast4',
  DOB: 'dob',
  LAST_LOGIN_ATTEMPT: 'lastLoginAttempt',
  IDENTIFIERS: 'identifiers'
};

/**
 * View to display the patient summary
 *
 * @class PatientSummaryView
 * @static
 * @param args {Object}
 *   @param [args.patientFacing=true] {boolean} whether the view is displayed to a patient or a staffer - will change where it looks for patient data
 *   @param [args.patientVecnaId] {String} the patient id if this view is for staff. Required if patientFacing is false.
 */
var PatientSummaryView = TorsoView.extend({
  tagName: 'section',
  className: 'portal-container portal-container--patient-summary',
  attributes: {
    'data-patient-summary': 'true'
  },
  moduleNamespace: 'patientSummary',
  template: patientSummaryTemplate,

  behaviors: {
    demographics: {
      behavior: DemographicsDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      id: { property: 'view:patientVecnaId' }
    }
  },

  /**
   * The list of field types available to display as part of the patient summary
   * @property FIELD_TYPES {Object}
   *   @property FIELD_TYPES.SSN_LAST_4 {String} The last four digits of the SSN
   *   @property FIELD_TYPES.DOB {String} The patient's date of birth
   *   @property FIELD_TYPES.LAST_LOGIN_ATTEMPT {String} The date/time that the last login attempt was made
   *   @property FIELD_TYPES.IDENTIFIERS {String} The available patient identifiers
   */
  FIELD_TYPES: FIELD_TYPES,

  /**
   * @method initialize
   * @override
   * @param args {Object}
   *   @param [args.patientFacing=true] {boolean} whether the view is displayed to a patient or a staffer - will change where it looks for patient data
   *   @param [args.patientVecnaId] {String} the patient id if this view is for staff. Required is patientFacing is false.
   */
  initialize: function(args) {
    var view = this;
    args = args || {};
    this._patientFacing = _.isUndefined(args.patientFacing) ? true : args.patientFacing;
    var fields = args.fields || [
      this.FIELD_TYPES.DOB,
      this.FIELD_TYPES.SSN_LAST_4,
      this.FIELD_TYPES.IDENTIFIERS
    ];
    this.set('fields', _.reduce(fields, function(map, type) {
      if (_.contains(view.FIELD_TYPES, type)) {
        map[type] = true;
      } else {
        throw 'Unsupported field type for patient summary: ' + type;
      }
      return map;
    }, {}));
    this.listenTo(this.viewState, 'change', this.render);
    if (this._patientFacing) {
      this._userModel = userService.currentUserModel;
      this._demographicsModel = userService.currentDemographicsModel;
      this.listenTo(this._userModel, 'change', this.render);
      this.listenTo(this._demographicsModel, 'change', this.render);
      userService.fetchModels();
    }
    this.set('patientVecnaId', args.patientVecnaId);

    this.listenTo(demographicsFeatureConfigModel, 'load-complete', this.render);
    demographicsFeatureConfigModel.loadOnce();
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function () {
    var context = TorsoView.prototype.prepare.call(this);

    var contactInfoConfig = demographicsFeatureConfigModel.get('normal.contactInfo');
    if (contactInfoConfig && contactInfoConfig.image) {
      context.showIdImage = contactInfoConfig.image.fieldPermissions !== 'DISABLED';
    }

    context.patientFacing = this._patientFacing;
    // Using context.demographics would get over written by the demographics data behavior.
    // Putting it on context.patient to avoid all that and determine here which model to use.
    if (context.patientFacing) {
      context.patient = this._demographicsModel.toJSON();
      context.user = this._userModel.toJSON();
    } else {
      context.patient = this.getBehavior('demographics').data.get();
    }
    context.noStaticContentServer = applicationUtils.currentApplication.noStaticContentServer;
    return context;
  },

  /**
   * @method changePatientVecnaId
   * @param patientVecnaId
   */
  changePatientVecnaId: function(patientVecnaId) {
    this.set('patientVecnaId', patientVecnaId);
  },

  /**
   * @override
   * @method _attached
   * @private
   */
  _attached: function() {
    if (!this._patientFacing) {
      this.getBehavior('demographics').fetch();
    }
  }
});

PatientSummaryView.FIELD_TYPES = FIELD_TYPES;

module.exports = PatientSummaryView;
